// extracted by mini-css-extract-plugin
export default {"header":"CancellationReason--header--ebf95c","button":"CancellationReason--button--39e071"};